$(document).ready(function () {
    cookies();
});

function cookies() {
    if ($('.cookies-message').length > 0) {
        setTimeout(function () {
            if (!$.cookie('cookie-policy')) {
                $('.cookies-message').addClass('show');
            }
        }, 1500);

        $('.cookies-message .button-wrapper button').on('click', function () {
            $('.cookies-message').removeClass('show');

            var d = new Date();

            d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();

            document.cookie = "cookie-policy=agree;" + expires + ";path=/";

            $(this).closest('.cookies-message').removeClass('show');
        });
    }
}